import script from "./Loader.vue?vue&type=script&setup=true&lang=ts"
export * from "./Loader.vue?vue&type=script&setup=true&lang=ts"

import "./Loader.vue?vue&type=style&index=0&id=a298da94&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a298da94"]])

export default __exports__